import * as React from 'react';
import { Box, Button, ButtonProps, CircularProgress } from '@mui/material';

import { ReactComponent as ArrowRight } from 'assets/images/arrow_right_1.svg';

interface SubmitButtonProps extends ButtonProps {
  loading?: boolean;
  label?: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

export const SubmitButton: React.FC<SubmitButtonProps> = (props) => {
  const { loading = false, onClick = () => {}, label = 'Submit', type = 'button' } = props;

  return (
    <Button
      size={props.size || 'large'}
      variant={props.variant || 'contained'}
      type={type}
      endIcon={
        loading ? (
          <Box
            sx={{
              width: props.size === 'medium' ? '32px' : '43.78px',
              marginLeft: props.size === 'medium' ? '8px' : '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <CircularProgress color="inherit" size={props.size === 'medium' ? 14 : 18} />
          </Box>
        ) : (
          <ArrowRight
            style={{
              width: props.size === 'medium' ? '32px' : '43.78px',
              marginLeft: props.size === 'medium' ? '8px' : '12px',
            }}
          />
        )
      }
      onClick={onClick}
      sx={{
        paddingLeft: 3,
        paddingRight: 6,
        ...props.sx,
      }}
      disabled={props.disabled || loading}
    >
      {label}
    </Button>
  );
};
